function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute("role", "button");
	summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

	if (summary.nextElementSibling.getAttribute("id")) {
		summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	}

	if ($(summary).hasClass("header__menu-item")) {
		summary.addEventListener("mouseenter", (event) => {
			event.currentTarget.setAttribute("aria-expanded", true);
			event.currentTarget.closest("details").setAttribute("open", true);
			$(".header-overlay").removeClass("hidden");
			// get all the details elements
			const details = document.querySelectorAll('[id^="Details-"]');
			// loop through each details element
			details.forEach((detail) => {
				// if the details element is not the one being hovered
				if (detail !== event.currentTarget.closest("details")) {
					// close it
					detail.removeAttribute("open");
					detail.querySelector("summary").setAttribute("aria-expanded", false);
				}
			});
		});
	} else if ($(summary).hasClass("footer--summary")) {
		summary.addEventListener("click", (event) => {
			event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
			$(event.currentTarget).find("h2").toggleClass("no-after");
		});
	}

	if (summary.closest("header-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && event.target !== last && event.target !== first) return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	elementToFocus.focus();

	if (
		elementToFocus.tagName === "INPUT" &&
		["search", "text", "email", "url"].includes(elementToFocus.type) &&
		elementToFocus.value
	) {
		elementToFocus.setSelectionRange(0, elementToFocus.value.length);
	}
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
	document.querySelector(":focus-visible");
} catch (e) {
	focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
	const navKeys = [
		"ARROWUP",
		"ARROWDOWN",
		"ARROWLEFT",
		"ARROWRIGHT",
		"TAB",
		"ENTER",
		"SPACE",
		"ESCAPE",
		"HOME",
		"END",
		"PAGEUP",
		"PAGEDOWN",
	];
	let currentFocusedElement = null;
	let mouseClick = null;

	window.addEventListener("keydown", (event) => {
		if (navKeys.includes(event.code.toUpperCase())) {
			mouseClick = false;
		}
	});

	window.addEventListener("mousedown", (event) => {
		mouseClick = true;
	});

	window.addEventListener(
		"focus",
		() => {
			if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

			if (mouseClick) return;

			currentFocusedElement = document.activeElement;
			currentFocusedElement.classList.add("focused");
		},
		true
	);
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((video) => {
		video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
	});
	document.querySelectorAll(".js-vimeo").forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("video").forEach((video) => video.pause());
	document.querySelectorAll("product-model").forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;

	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });

		this.input.addEventListener("change", this.onInputChange.bind(this));
		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onButtonClick.bind(this))
		);
	}

	quantityUpdateUnsubscriber = undefined;

	connectedCallback() {
		this.validateQtyRules();
		this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
	}

	disconnectedCallback() {
		if (this.quantityUpdateUnsubscriber) {
			this.quantityUpdateUnsubscriber();
		}
	}

	onInputChange(event) {
		this.validateQtyRules();
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
	}

	validateQtyRules() {
		const value = parseInt(this.input.value);
		if (this.input.min) {
			const min = parseInt(this.input.min);
			const buttonMinus = this.querySelector(".quantity__button[name='minus']");
			// buttonMinus.classList.toggle('disabled', value <= min);
			if (value <= min) this.addDeleteButton(buttonMinus);
		}
		if (this.input.max) {
			const max = parseInt(this.input.max);
			const buttonPlus = this.querySelector(".quantity__button[name='plus']");
			buttonPlus.classList.toggle("disabled", value >= max);
		}
	}

	addDeleteButton(buttonMinus) {
		const button = $(buttonMinus);
		button.toggleClass("delete");
		button.bind("click", ".delete", () => {
			$(this).parent().find("cart-remove-button button").click();
		});
	}
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: { "Content-Type": "application/json", Accept: `application/${type}` },
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (let i = 0, count = selector.options.length; i < count; i++) {
		let option = selector.options[i];
		if (value === option.value || value === option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

	Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector("details");

		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll("summary").forEach((summary) =>
			summary.addEventListener("click", this.onSummaryClick.bind(this))
		);
		if (window.innerWidth > 990) {
			this.querySelectorAll("summary").forEach((summary) =>
				summary.addEventListener("mouseenter", this.onSummaryHover.bind(this))
			);
		}
		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onCloseButtonClick.bind(this))
		);
		if (document.querySelector(".desktop-account-modal button") !== null) {
			document
				.querySelector(".desktop-account-modal button")
				.addEventListener("click", this.onCloseButtonClick.bind(this));
		}
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		let summaryElement = event.currentTarget;
		let detailsElement = summaryElement.parentNode;
		let parentMenuElement = detailsElement.closest(".has-submenu");
		let isOpen = detailsElement.hasAttribute("open") || $(detailsElement).attr("open") === true;
		let reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

		if ($(summaryElement).hasClass("header__icon--summary")) {
			$(".header-overlay").removeClass("hidden");
			$(".header-wrapper").addClass("blackend");
			$(".account-menu-details").removeAttr("open");
		}

		$(".mobile-facets__close").click(function () {
			$("html").removeClass("overflow-hidden");
			$(".details.menu-opening").removeClass("menu-opening");
			$(".mobile-facets__disclosure.menu-opening").removeAttr("open");
		});

		function addTrapFocus() {
			// trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
			// summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
		}

		if (isOpen === false) {
			$("html").addClass("overflow-hidden");
			if (summaryElement.classList.contains("mobile-facets__open-wrapper")) {
				$(".facets-wrapper").addClass("high-index");
			}
		} else {
			$("html").removeClass("overflow-hidden");
			if (summaryElement.classList.contains("mobile-facets__open-wrapper")) {
				$(".facets-wrapper").removeClass("high-index");
			}
		}

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

			if (window.matchMedia("(max-width: 990px)")) {
				// document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

				function getViewportHeightForMenu() {
					let viewportHeight = window.innerHeight * 0.01;
					document.documentElement.style.setProperty("--viewport-height", `${viewportHeight}px`);
				}

				window.addEventListener("resize", getViewportHeightForMenu);

				getViewportHeightForMenu();
			}
		} else {
			setTimeout(() => {
				detailsElement.classList.add("menu-opening");
				summaryElement.setAttribute("aria-expanded", true);
				parentMenuElement && parentMenuElement.classList.add("submenu-open");
				!reducedMotion || reducedMotion.matches
					? addTrapFocus()
					: summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
			}, 100);
		}
	}

	onSummaryHover(event) {
		if (window.innerWidth > 990) {
			let summaryElementHover = event.target;
			let detailsElementHover = summaryElementHover.parentNode;
			let parentMenuElementHover = detailsElementHover.closest(".has-submenu");
			let isOpenHover = detailsElementHover.hasAttribute("open");
			let reducedMotionHover = window.matchMedia("(prefers-reduced-motion: reduce)");

			function addTrapFocus() {
				trapFocus(summaryElementHover.nextElementSibling, detailsElementHover.querySelector("button"));
				summaryElementHover.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
			}

			if (detailsElementHover === this.mainDetailsToggle) {
				if (isOpenHover) event.preventDefault();
				isOpenHover ? this.closeMenuDrawer(event, summaryElementHover) : this.openMenuDrawer(summaryElementHover);

				if (window.matchMedia("(max-width: 990px)")) {
					document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
				}
			} else {
				setTimeout(() => {
					detailsElementHover.classList.add("menu-opening");
					summaryElementHover.setAttribute("aria-expanded", true);
					parentMenuElementHover && parentMenuElementHover.classList.add("submenu-open");
					!reducedMotionHover || reducedMotionHover.matches
						? addTrapFocus()
						: summaryElementHover.nextElementSibling.addEventListener("transitionend", addTrapFocus);
				}, 100);
			}
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});
		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		// document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event === undefined) return;

		this.mainDetailsToggle.classList.remove("menu-opening");
		this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
			details.removeAttribute("open");
			details.classList.remove("menu-opening");
		});
		this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
			submenu.classList.remove("submenu-open");
		});
		// document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
		removeTrapFocus(elementToFocus);
		this.closeAnimation(this.mainDetailsToggle);
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement))
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement);
		if (!event.target.classList.contains("dropdown__search--close")) {
			let mobileHeaderMenuItem = $(".mobile_menu_link.header__menu-item");
			mobileHeaderMenuItem.removeClass("hidden").removeClass("active");
			mobileHeaderMenuItem.parent().css("display", "flex");
			$(".header-overlay").addClass("hidden");
			$("html").removeClass("overflow-hidden");
			$(".header-wrapper").removeClass("blackend");
			if (window.matchMedia("(max-width: 990px)")) {
				document.documentElement.style.removeProperty("--viewport-height");
			}
		}
	}

	closeSubmenu(detailsElement) {
		const parentMenuElement = detailsElement.closest(".submenu-open");
		parentMenuElement && parentMenuElement.classList.remove("submenu-open");
		detailsElement.classList.remove("menu-opening");
		detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
		removeTrapFocus(detailsElement.querySelector("summary"));
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute("open");
				if (detailsElement.closest("details[open]")) {
					trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header = this.header || document.querySelector(".section-header");
		this.borderOffset =
			this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
		document.documentElement.style.setProperty(
			"--header-bottom-position",
			`${parseInt(this.header.getBoundingClientRect().bottom)}px`
		);
		this.header.classList.add("menu-open");

		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});

		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		// document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus) {
		super.closeMenuDrawer(event, elementToFocus);
		this.header.classList.remove("menu-open");
	}
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false));
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
		if (this.classList.contains("media-modal")) {
			this.addEventListener("pointerup", (event) => {
				if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) this.hide();
			});
		} else {
			this.addEventListener("click", (event) => {
				if (event.target === this) this.hide();
			});
		}
	}

	connectedCallback() {
		if (this.moved) return;
		this.moved = true;
		document.body.appendChild(this);
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector(".template-popup");
		// document.body.classList.add('overflow-hidden');
		this.setAttribute("open", "");
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		// document.body.classList.remove('overflow-hidden');
		// document.body.dispatchEvent(new CustomEvent('modalClosed'));
		this.removeAttribute("open");
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();
	}
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector("button");

		if (!button) return;
		button.addEventListener("click", () => {
			const modal = document.querySelector(this.getAttribute("data-modal"));
			if (modal) modal.show(button);
		});
	}
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');
		if (!poster) return;
		poster.addEventListener("click", this.loadContent.bind(this));
	}

	loadContent(focus = true) {
		window.pauseAllMedia();
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

			this.setAttribute("loaded", true);
			const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
			if (focus) deferredElement.focus();
		}
	}
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector('[id^="Slider-"]');
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
		this.enableSliderLooping = true;
		this.currentPageElement = this.querySelector(".slider-counter--current");
		this.pageTotalElement = this.querySelector(".slider-counter--total");
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');
		if (this.querySelector(".slider-component-progress-bar") !== null) {
			this.progressBar = this.querySelector(".slider-component-progress-bar");
		}

		if (!this.slider || !this.nextButton) return;

		this.initPages();
		this.moveProgressBar();
		const resizeObserver = new ResizeObserver((entries) => this.initPages());
		resizeObserver.observe(this.slider);

		this.slider.addEventListener("scroll", this.update.bind(this));
		this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
		this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
	}

	initPages() {
		// this.totalPages = this.sliderItemsToShow.length;
		this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
		if (this.sliderItemsToShow.length < 2) return;
		this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
		this.slidesPerPage = Math.floor(
			(this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
		);
		this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
		// this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage;
		this.update();
	}

	resetPages() {
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
		this.initPages();
	}

	moveProgressBar() {
		if (this.progressBar) {
			this.progressBar.style.left = `${((this.currentPage - 1) * 100) / (this.totalPages - 1)}%`;
			this.progressBar.style.width = `${100 / (this.totalPages - 1)}%`;
		}
	}
	update() {
		// Temporarily prevents unneeded updates resulting from variant changes
		// This should be refactored as part of https://github.com/Shopify/dawn/issues/2057

		this.moveProgressBar();

		if (!this.slider || !this.nextButton) return;

		const previousPage = this.currentPage;
		this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

		if (this.currentPageElement && this.pageTotalElement) {
			this.currentPageElement.textContent = this.currentPage;
			this.pageTotalElement.textContent = this.totalPages;
		}

		if (this.currentPage !== previousPage) {
			this.dispatchEvent(
				new CustomEvent("slideChanged", {
					detail: {
						currentPage: this.currentPage,
						currentElement: this.sliderItemsToShow[this.currentPage - 1],
					},
				})
			);
		}

		if (this.enableSliderLooping) return;

		if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
			this.prevButton.setAttribute("disabled", "disabled");
		} else {
			this.prevButton.removeAttribute("disabled");
		}

		if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
			this.nextButton.setAttribute("disabled", "disabled");
		} else {
			this.nextButton.removeAttribute("disabled");
		}
	}

	isSlideVisible(element, offset = 0) {
		const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
		return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
	}

	onButtonClick(event) {
		event.preventDefault();
		const step = event.currentTarget.dataset.step || 1;
		this.slideScrollPosition =
			event.currentTarget.name === "next"
				? this.slider.scrollLeft + step * this.sliderItemOffset
				: this.slider.scrollLeft - step * this.sliderItemOffset;

		if (this.enableSliderLooping) {
			if (this.slideScrollPosition < 0) {
				this.slideScrollPosition = (this.totalPages - 1) * this.sliderItemOffset;
			} else if (Math.round(this.slideScrollPosition / this.sliderItemOffset) >= this.totalPages) {
				this.slideScrollPosition = 0;
			}
		}

		this.slider.scrollTo({
			left: this.slideScrollPosition,
			behavior: "smooth",
		});
	}
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
	constructor() {
		super();
		this.sliderControlWrapper = this.querySelector(".slider-buttons");
		this.enableSliderLooping = true;

		if (!this.sliderControlWrapper) return;

		this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
		if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

		this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
		this.sliderControlLinksArray.forEach((link) => link.addEventListener("click", this.linkToSlide.bind(this)));
		this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
		this.setSlideVisibility();

		if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
	}

	setAutoPlay() {
		this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
		this.autoplaySpeed = this.slider.dataset.speed * 1000;

		this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
		this.addEventListener("mouseover", this.focusInHandling.bind(this));
		this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
		this.addEventListener("focusin", this.focusInHandling.bind(this));
		this.addEventListener("focusout", this.focusOutHandling.bind(this));

		this.play();
		this.autoplayButtonIsSetToPlay = true;
	}

	onButtonClick(event) {
		super.onButtonClick(event);
		const isFirstSlide = this.currentPage === 1;
		const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

		if (!isFirstSlide && !isLastSlide) return;

		if (isFirstSlide && event.currentTarget.name === "previous") {
			this.slideScrollPosition =
				this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
		} else if (isLastSlide && event.currentTarget.name === "next") {
			this.slideScrollPosition = 0;
		}
		this.slider.scrollTo({
			left: this.slideScrollPosition,
		});
	}

	update() {
		super.update();
		this.rects = this.querySelectorAll(".slideshow--rect");
		this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
		this.prevButton.removeAttribute("disabled");

		if (!this.sliderControlButtons.length) return;

		this.sliderControlButtons.forEach((link) => {
			link.classList.remove("slider-counter__link--active");
			link.removeAttribute("aria-current");
		});
		this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
		this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);

		if (this.rects && this.rects.length) {
			this.rects.forEach((rect) => {
				rect.classList.remove("slideshow--rect--active");
				rect.removeAttribute("aria-current");
			});
			this.rects[this.currentPage - 1].classList.add("slideshow--rect--active");
			this.rects[this.currentPage - 1].setAttribute("aria-current", true);
			$(this.rects[this.currentPage - 1])
				.find(".slideshow--rect-filler")
				.css("animation-duration", this.autoplaySpeed + "ms");
		}
	}

	autoPlayToggle() {
		this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
		this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
		this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
	}

	focusOutHandling(event) {
		const focusedOnAutoplayButton =
			event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
		if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
		this.play();
	}

	focusInHandling(event) {
		const focusedOnAutoplayButton =
			event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
		if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
			this.play();
		} else if (this.autoplayButtonIsSetToPlay) {
			this.pause();
		}
	}

	play() {
		this.slider.setAttribute("aria-live", "off");
		clearInterval(this.autoplay);
		this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
	}

	pause() {
		this.slider.setAttribute("aria-live", "polite");
		clearInterval(this.autoplay);
	}

	togglePlayButtonState(pauseAutoplay) {
		if (pauseAutoplay) {
			this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
			this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow);
		} else {
			this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
			this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow);
		}
	}

	autoRotateSlides() {
		const slideScrollPosition =
			this.currentPage === this.sliderItems.length
				? 0
				: this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}

	setSlideVisibility() {
		this.sliderItemsToShow.forEach((item, index) => {
			const linkElements = item.querySelectorAll("a");
			if (index === this.currentPage - 1) {
				if (linkElements.length)
					linkElements.forEach((button) => {
						button.removeAttribute("tabindex");
					});
				item.setAttribute("aria-hidden", "false");
				item.removeAttribute("tabindex");
			} else {
				if (linkElements.length)
					linkElements.forEach((button) => {
						button.setAttribute("tabindex", "-1");
					});
				item.setAttribute("aria-hidden", "true");
				item.setAttribute("tabindex", "-1");
			}
		});
	}

	linkToSlide(event) {
		event.preventDefault();
		const slideScrollPosition =
			this.slider.scrollLeft +
			this.sliderFirstItemNode.clientWidth *
				(this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange);
	}

	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, "", false);
		this.updatePickupAvailability();
		this.removeErrorMessage();
		this.updateVariantStatuses();

		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
		} else {
			// this.updateMedia();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
			this.updateShareUrl();
		}
	}

	updateOptions() {
		this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);
		});
	}

	updateMedia() {
		if (!this.currentVariant) return;
		if (!this.currentVariant.featured_media) return;

		const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
		mediaGalleries.forEach((mediaGallery) =>
			mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
		);

		const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
		if (!modalContent) return;
		const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
		modalContent.prepend(newMediaModal);
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === "false") return;
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	updateShareUrl() {
		const shareButton = document.getElementById(`Share-${this.dataset.section}`);
		if (!shareButton || !shareButton.updateUrl) return;
		shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(":checked").value === variant.option1
		);
		const inputWrappers = [...this.querySelectorAll(".product-form__input")];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
			const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
				.map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				input.innerText = input.getAttribute("value");
			} else {
				input.innerText = window.variantStrings.unavailable_with_option.replace("[value]", input.getAttribute("value"));
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability");
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute("available");
			pickUpAvailability.innerHTML = "";
		}
	}

	removeErrorMessage() {
		const section = this.closest("section");
		if (!section) return;

		const productForm = section.querySelector("product-form");
		if (productForm) productForm.handleErrorMessage();
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

		fetch(
			`${this.dataset.url}?variant=${requestedVariantId}&section_id=${
				this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
			}`
		)
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(responseText, "text/html");
				const destination = document.getElementById(`price-${this.dataset.section}`);
				const source = html.getElementById(
					`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
				);
				const skuSource = html.getElementById(
					`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
				);
				const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
				const inventorySource = html.getElementById(
					`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
				);
				const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

				if (source && destination) destination.innerHTML = source.innerHTML;
				if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML;
					skuDestination.classList.toggle("visibility-hidden", skuSource.classList.contains("visibility-hidden"));
				}

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove("visibility-hidden");

				if (inventoryDestination)
					inventoryDestination.classList.toggle("visibility-hidden", inventorySource.innerText === "");

				const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
				this.toggleAddButton(
					addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
					window.variantStrings.soldOut
				);

				publish(PUB_SUB_EVENTS.variantChange, {
					data: {
						sectionId,
						html,
						variant: this.currentVariant,
					},
				});
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute("disabled", "disabled");
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute("disabled");
			addButtonText.textContent = window.variantStrings.addToCart;
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);

		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
		if (price) price.classList.add("visibility-hidden");
		if (inventory) inventory.classList.add("visibility-hidden");
		if (sku) sku.classList.add("visibility-hidden");
	}

	getVariantData() {
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				input.classList.remove("disabled");
			} else {
				input.classList.add("disabled");
			}
		});
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
		});
	}
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement("div");
					html.innerHTML = text;
					const recommendations = html.querySelector("product-recommendations");

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}

					if (
						(!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) ||
						recommendations.innerHTML.trim().length < 2500
					) {
						this.remove();
					}

					if (html.querySelector(".grid__item")) {
						this.classList.add("product-recommendations--loaded");
					}
				})
				.catch((e) => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
	}
}

customElements.define("product-recommendations", ProductRecommendations);

let contentToRender = document.getElementById("ProductGridContainer");

function removeDeadProduct() {
	$("#product-grid").siblings("#AjaxinatePagination").find(".loading-overlay__spinner").removeClass("hidden");
	let listItems = document.querySelectorAll(".grid__item");
	listItems.forEach((item) => {
		if (item.childNodes.length === 1) {
			item.remove();
		}
	});

	$(".account-toggler-site-wide").click(function () {
		$(".custom-customer-account-container").addClass("active");
		$(".custom-login-overlay").removeClass("hidden");

		if ($(".drawer").hasClass("active")) {
			$(".drawer").removeClass("active");
		}
	});
}

// window.addEventListener("beforeunload", function(event) {
// 	localStorage.setItem("content", contentToRender.innerHTML);
// 	localStorage.setItem("collectionHandle", window.location.href.split('collections/')[1]);
// });
//
// // check if on collection page
// if (contentToRender !== null) {
//
// 	let previousCollectionHandle = localStorage.getItem("collectionHandle");
//
// 	let currentURL = window.location.href;
// 	let splitURL = currentURL.split("collections/");
// 	let collectionHandle = splitURL[1];
//
// 	// set the HTML to the stored HTML
// 	let updatedContent = localStorage.getItem("content");
//
// 	// if there is stored HTML, update the page
// 	if (updatedContent !== null && collectionHandle === previousCollectionHandle) {
// 		 contentToRender.innerHTML = updatedContent;
// 	}
// }

window.addEventListener("DOMContentLoaded", function (event) {
	if (document.querySelector(".filter-links") !== null) {
		let filterLinks = document.querySelectorAll(".filter-link");
		let windowWidth = window.innerWidth;
		if (windowWidth < 750) {
			filterLinks.forEach((link) => {
				if (link.classList.contains("current-link")) {
					console.log(link);
					link.scrollIntoView();
				}
			});
		}
	}

	if (document.querySelector("#countdown") !== null) {
		$("facets-container").addClass("countdown-facet");
		$("facets-wrapper").addClass("countdown-facet");
	} else {
		$("facets-container").removeClass("countdown-facet");
		$("facets-wrapper").removeClass("countdown-facet");
	}

	// account modal code start here

	const listItem = $(".multicolumn-list__item");
	const itemIsLoginOrRegister = document.querySelector("main").dataset.template;
	const registerListItem = $(`.multicolumn-list__item[data-account="${itemIsLoginOrRegister}"]`);
	const customerOverlay = $(".custom-login-overlay");
	const borderPosition = $("#js-border-position");
	let cartDrawer = $(".drawer");
	let customerSection;
	let secondaryLogo;

	if (document.querySelector("#shopify-section-main-login") !== null) {
		document.querySelector("#shopify-section-main-login").classList.add("hidden");
	}

	function openLoginModal() {
		$(".custom-customer-account-container").addClass("active");
		customerOverlay.removeClass("hidden");

		// Force the register tab to be active.
		let registerItem = $(".multicolumn-list__item[data-account='register']");
		if (registerItem.length) {
			// Add active state to register item and remove it from siblings.
			registerItem.addClass("active").siblings().removeClass("active");

			// If you have a border indicator, update its position.
			if (borderPosition.length) {
				let activeWidth = registerItem.innerWidth();
				let position = registerItem.position();
				borderPosition.css("width", activeWidth + "px").css("left", position.left + "px");
			}

			// Show the proper section if it exists.
			let customerSection = $(`div[id$="register"]`);
			if (customerSection.length) {
				customerSection.removeClass("hidden").siblings('div[id^="shopify-section"]').addClass("hidden");
			}
		}

		if (cartDrawer.hasClass("active")) {
			cartDrawer.removeClass("active");
		}
	}

	// account toggler site-wide
	$(".account-toggler-site-wide").click(openLoginModal);

	$(".close-custom-account-container").click(closePopup);
	customerOverlay.click(closePopup);

	function closePopup() {
		$(".custom-customer-account-container").removeClass("active");
		customerOverlay.addClass("hidden");
	}

	function animations(element) {
		if (borderPosition === null || element === null || element.attr("data-account") === undefined) return;
		secondaryLogo = document.querySelector(".header__heading-logo_secondary");
		if (secondaryLogo !== null) {
			if (element.attr("data-account") === "login") {
				secondaryLogo.classList.remove("hidden");
			} else {
				secondaryLogo.classList.add("hidden");
			}
		}
		element.addClass("active");
		element.siblings().removeClass("active");
		let activeWidth = element.innerWidth();
		let position = element.position();
		borderPosition.css("width", activeWidth + "px");
		borderPosition.css("left", position.left + "px");
		customerSection = document.querySelector(`div[id$="${element.attr("data-account")}"]`);
		if (customerSection === null) return;
		customerSection.classList.remove("hidden");
		$(customerSection).siblings('div[id^="shopify-section"]').addClass("hidden");
	}

	listItem.on("click", function () {
		animations($(this));
	});

	animations(registerListItem);

	// account modal code ends here

	const shopByColorLink = $("#page .section-collection-list:nth-child(3) .grid__item .card .full-unstyled-link");

	if (window.innerWidth < 990) {
		shopByColorLink.on("click", function (event) {
			$(event.target).parents(".card").css("border", "1px solid black");
		});
	} else {
		shopByColorLink.on("mouseenter", function (event) {
			$(event.target).parents(".card").css("border", "1px solid black");
		});

		shopByColorLink.on("mouseleave", function (event) {
			$(event.target).parents(".card").css("border", "1px solid #f0f0f0");
		});
	}

	let scrollbarTrack = $(".scroll-track");
	let scrollbarSlider = scrollbarTrack.siblings("ul");
	let scrollbarThumb = scrollbarTrack.find(".scroll-thumb");
	// make scrollbar thumb width dynamic

	if (scrollbarTrack.length) {
		scrollbarThumb.css("width", (scrollbarSlider.width() / scrollbarSlider[0].scrollWidth) * 100 + "%");
		scrollbarSlider.on("scroll", function () {
			scrollbarThumb.css("left", (scrollbarSlider.scrollLeft() / scrollbarSlider[0].scrollWidth) * 100 + "%");
		});
	}

	$(".collection-banner-section").on("click", function () {
		$(this).toggleClass("active");
		$(this).find(".icon-caret").toggleClass("active");
	});

	function toggleButtonLoading() {
		$(this).find(".button-loader-text").addClass("zero-opacity");
		$(this).find(".loading-overlay__spinner").removeClass("hidden");
		$(this).find(".loading-overlay").show();
		$(this).css("opacity", "0.5");

		setTimeout(() => {
			$(this).find(".button-loader-text").removeClass("zero-opacity");
			$(this).find(".loading-overlay__spinner").addClass("hidden");
			$(this).find(".loading-overlay").hide();
			$(this).css("opacity", "1");
		}, 5000);
	}

	$(".button-loader-activator").on("click", toggleButtonLoading);

	removeDeadProduct();

	$(".loader-wrapper").delay().fadeOut("slow");

	let headerOverlay = $(".header-overlay");
	let menuDrawer = document.querySelector("header-drawer");

	$(".header-block-list-element .closing-link").on("mouseenter", function (event) {
		$("details.mega-menu").attr("open", false);
		headerOverlay.addClass("hidden");
	});

	function closeHeader(event) {
		$("html").removeClass(`overflow-hidden-${menuDrawer.dataset.breakpoint}`).removeClass("overflow-hidden");
		$(".menu-drawer-container.menu-opening").attr("open", false).removeClass("menu-opening");
		$("details.account-menu-details").attr("open", false);
		headerOverlay.addClass("hidden");
		$(".header-wrapper").removeClass("blackend");
	}

	$(".header-overlay").on("click", closeHeader);
	if (window.innerWidth > 990) {
		headerOverlay.on("mouseenter", function () {
			$(this).addClass("hidden");
			$(".header__menu-item").attr("aria-expanded", false);
			$("details.mega-menu").removeAttr("open");
			$("details.account-menu-details").removeAttr("open");
			$(".menu-drawer-container").removeAttr("open");
			// document.body.classList.remove(`overflow-hidden-${menuDrawer.dataset.breakpoint}`);
		});
	}

	const enableToolbarButton = document.querySelector("#enable-toolbar-trigger");
	const pill = document.querySelector(".icon-pill");
	const pillBorder = document.querySelector(".icon-pill-border");

	enableToolbarButton.appendChild(pill);
	enableToolbarButton.appendChild(pillBorder);

	// let cartItemsInstance = new CartItems();
	// let historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
	//
	// // re-render the cart if the user clicked the back button
	// if (historyTraversal) {
	// 	cartItemsInstance.onCartUpdate();
	// }
});

// window.addEventListener('popstate', function(event) {
// 	console.log(event);
// 	let cartItemsInstance = new CartItems();
// 	// let cartItemsInstance = document.querySelector('cart-items');
// 	cartItemsInstance.onCartUpdate();
//
// });

// check the previous window url
function checkUrl() {
	let previousUrl = sessionStorage.getItem("previousUrl");
	if (previousUrl) {
		if (previousUrl.includes("checkout")) {
			window.location.reload();
		}
	}
}

if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
	checkUrl();
}

let customerEmailForFlashy;

document.addEventListener("hiko", (event) => {
	if (event.detail.action === "login" || event.detail.action === "activate") {
		customerEmailForFlashy = event.detail.email;
		flashy.contacts.create(
			{
				email: customerEmailForFlashy,
			},
			18665
		);
	}
});
$(document).on("click", ".multicolumn-list__item", function () {
	// Remove active state from siblings and add to the clicked element
	$(this).addClass("active").siblings().removeClass("active");
});

$(document).on("click", ".account-toggler-site-wide", function () {
	sessionStorage.setItem("redirectAfterLogin", window.location.pathname + window.location.search);
	$("#return_to_login, #return_to_register").val(window.location.pathname + window.location.search);
});
